import ArrivalDraught from "./sections/ArrivalDraught";
import CargoOnboard from "./sections/CargoOnboard";
import Confirmation from "./sections/Confirmation";
import DeadWeight from "./sections/DeadWeight";
import DepartureDraught from "./sections/DepartureDraught";
import Displacement from "./sections/Displacement";
import Drafts from "./sections/Drafts";
import LastPscInspection from "./sections/LastPscInspection";
import LastSireInspection from "./sections/LastSireInspection";
import Manifolds from "./sections/Manifolds";
import Mooring from "./sections/Mooring";
import PaqDocument from "./sections/PaqDocument";
import TypeAndQuantityOfCargo from "./sections/ParcelsSection";
import TechnicalDetails from "./sections/TechnicalDetails";
import Tonnage from "./sections/Tonnage";
import ToxicComponent from "./sections/ToxicComponent";
import VesselDetails from "./sections/VesselDetails";
import VoyageInformation from "./sections/VoyageInformation";

export const LANG_BASE = "vessel-nomination.add.form";
const TEST_ID_BASE = "pre-arrival-questionnaire";

const PreArrivalQuestionnaire = () => {
  return (
    <div data-testid="vessel-information-page" className="pb-8">
      <div className="min-w-full flex flex-col gap-8 pb-8" data-testid={TEST_ID_BASE}>
        <VesselDetails />
        <TechnicalDetails />
        <Drafts />
        <ArrivalDraught />
        <DepartureDraught />
        <Tonnage />
        <Displacement />
        <DeadWeight />
        <Manifolds />
        <CargoOnboard />
        <TypeAndQuantityOfCargo />
        <ToxicComponent />
        <Mooring />
        <LastSireInspection />
        <LastPscInspection />
        <VoyageInformation />
        <PaqDocument />
        <Confirmation />
      </div>
    </div>
  );
};

export default PreArrivalQuestionnaire;
